module.exports = __webpack_public_path__ + "img/albania.2bc7f480.png";